import { writable } from "svelte/store";
import type { WindowLocation } from "@shared/types/WindowLocation";

const initialWindowLocation: WindowLocation = {
  location: {},
  stateParams: {},
};
const WindowLocationStore = writable<WindowLocation>(initialWindowLocation);

export default WindowLocationStore;
